import { useIsDesktopDevice } from "../../tools/hooks/useIsDesktopDevice.ts";
import UserDialogDesktopView from "./desktop/UserDialog.desktop.view.tsx";
import type UserDialogProperties from "./UserDialog.properties.ts";

export default function UserDialogView(props: UserDialogProperties) {
  const isDesktop = useIsDesktopDevice();

  return <>{isDesktop && <UserDialogDesktopView {...props} />}</>;
}
